export default function(data, calling_page) {
  var self = this;

  const page = calling_page;

  self.$el = $('#admin_course_listing');
  self.$category_modal = $('#category_modal');
  self.$invite_modal = $('#course_invite_modal');
  self.$category_input = $('#selected_categories');
  self.$first_name_search_input = $('#user_search_first_name');
  self.$last_name_search_input = $('#user_search_last_name');
  self.$email_search_input = $('#user_search_email');


  self.roles = ko.observableArray(['Instructor', 'Student', 'TA', 'Staff', 'Instructional Support', 'GTA']);

  self.courses = ko.observableArray();
  self.total_courses = ko.observable();
  self.published_courses = ko.observableArray();
  self.pending_courses = ko.observableArray();
  self.draft_courses = ko.observableArray();
  self.archived_courses = ko.observableArray();
  self.categories = ko.observableArray();
  self.terms = ko.observableArray();
  self.selected_terms = ko.observableArray();
  self.selected_sort = ko.observable();
  self.published_courses_paginator = ko.observable();
  self.pending_courses_paginator = ko.observable();
  self.draft_courses_paginator = ko.observable();
  self.archived_courses_paginator = ko.observable();

  self.selected_course = ko.observable();
  self.selected_invitee = ko.observable({
    first_name: ko.observable(),
    last_name: ko.observable(),
    email: ko.observable(),
    role: ko.observable(),
    course_creator: ko.observable(true)
  });

  self.checkedCategories = ko.observableArray();
  self.searchQuery = ko.observable();

  self.sort_options = ko.observableArray([
    { id: 1, name: 'Course Number Ascending', param: 'number', direction: 'asc'  },
    { id: 2, name: 'Course Number Descending', param: 'number', direction: 'desc'  },
    { id: 3, name: 'Name Ascending', param: 'name', direction: 'asc' },
    { id: 4, name: 'Name Descending', param: 'name', direction: 'desc' }
  ]);
  self.selected_sort = ko.observable(0);

  self.bindData = function(data) {
    var mapped_published_courses = ko.mapping.fromJS(data.courses.published_courses),
      mapped_pending_courses = ko.mapping.fromJS(data.courses.pending_courses),
      mapped_draft_courses = ko.mapping.fromJS(data.courses.draft_courses),
      mapped_archived_courses = ko.mapping.fromJS(data.courses.archived_courses),
      mapped_courses = _.flatten([mapped_published_courses(), mapped_pending_courses(), mapped_draft_courses(), mapped_archived_courses()]),
      mapped_categories = ko.mapping.fromJS(data.categories),
      mapped_terms = ko.mapping.fromJS(data.terms);

    self.total_courses(data.total_courses)
    self.published_courses(mapped_published_courses());
    self.published_courses_paginator(data.paginators.published_courses);

    self.pending_courses(mapped_pending_courses());
    self.pending_courses_paginator(data.paginators.pending_courses);

    self.draft_courses(mapped_draft_courses());
    self.draft_courses_paginator(data.paginators.draft_courses);

    self.archived_courses(mapped_archived_courses());
    self.archived_courses_paginator(data.paginators.archived_courses);

    self.categories(mapped_categories());
    self.terms(mapped_terms());

    self.pending_courses_count = ko.computed(function() {
      return self.pending_courses().length;
    });

    if (data.selectedCategoryId) {
      self.checkedCategories.push(parseInt(data.selectedCategoryId));
    }

    self.courses(_.compact(mapped_courses));
  };

  self.initUI = function() {
    self.initCategoryTypeahead();
    self.initCoursePersonnelTypeaheads();
    self.bindPaginationEvents();

    $('#courseSearch').on('keypress', function(event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if(keycode == '13') {
        $('#courseSearch').blur();
        self.filterChanged();
      }
    });
  };

  self.resetSelected = function() {
    self.client_errors = ko.validation.group(self.selected_invitee(), { deep: true });
    self.selected_invitee().first_name('');
    self.selected_invitee().last_name('');
    self.selected_invitee().email('');
    self.selected_invitee().role('');
    self.selected_course(null);
    self.client_errors.showAllMessages(false);
  };

  self.bindPaginationEvents = function() {
    self.page_number = $('.page_number');
    var total_pages = parseInt($('.total_pages').text()),
      current_page = parseInt($('.current_page').text());

    self.page_number.keyup(function(e){
      if(e.keyCode == 13){
        changePage($(this).val());
      }
    });
    self.page_number.blur(function(e){
      changePage($(this).val());
    });

    $('.pagination a').off('click');
    $('.pagination a').on('click', function() {
      var url = $(this).attr('href');
      if (url != '#') {
        self.courseListing(url, { course_list: self.getActiveTab() });
      }
      return false;
    });

    var changePage = function(pageNumber){
      if (parseInt(pageNumber)) {
        var destination_page = (pageNumber <= total_pages) ? pageNumber : total_pages;
        var url = Kadenze.Routes.admin_courses_path() + '?page=' + destination_page;
        self.courseListing(url, { course_list: self.getActiveTab() });
      } else {
        self.page_number.val(current_page);
      }
    };

  };

  /*----------------------------------------COURSE PERSONNEL INVITE FUNCTIONS-----------------------------------------*/
  self.initSearchEngine = function(type) {
    var instructorSearch = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace(type),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      limit: 5,
      remote: {
        url: Kadenze.Routes.list_admin_users_path({ q: '%QUERY', type }),
        filter: function(instructors) {
          return $.map(instructors, function(instructor) { return { name: instructor.full_name, first_name: instructor.first_name, last_name: instructor.last_name, email: instructor.email }; });
        },
        ajax: {
          dataType: 'json',
          contentType: 'application/json',
          beforeSend: function() {
            //TODO: Show progress indicator
            $('.status_indicator').html('Searching...');
          },
          complete: function() {
            //TODO: Hide progress indicator
            $('.status_indicator').html('');
          }
        }
      }
    });

    instructorSearch.initialize();

    return instructorSearch;
  };

  self.initTypeahead = function($element, key) {
    var searchEngine = self.initSearchEngine(key);

    $element.typeahead({
      hint: false,
      highlight: true,
      minLength: 1
    },
    {
      name: 'users',
      displayKey: key,
      source: searchEngine.ttAdapter()
    });

    $element.on('typeahead:selected', self.inviteeSelected);
  };

  self.inviteeSelected = function(obj, datum) {
    self.selected_invitee().first_name(datum.first_name);
    self.selected_invitee().last_name(datum.last_name);
    self.selected_invitee().email(datum.email);
  };

  self.initCoursePersonnelTypeaheads = function() {
    self.initTypeahead(self.$first_name_search_input, 'name');
    self.initTypeahead(self.$last_name_search_input, 'name');
    self.initTypeahead(self.$email_search_input, 'email');
  };

  self.selectCoursePersonnel = function(item, event) {
    //Hack to make sure course creator is checked by default
    self.selected_invitee().course_creator(true);
    $('#allow_course_creation').prop('checked', true);
    $('label[for=allow_course_creation]').css('background-position', '0px -32px');

    self.selected_course(item);
    self.$invite_modal.modal('show');
  };

  self.inviteCoursePersonnel = function(item, event) {
    if (self.selected_course().is_pending() && self.selected_invitee().role() == 'Student') {
      Kadenze.UIUtil.confirmAction(I18n.t('dict.draft_course_invite_confirm_message'), function() {
        self.invite();
      });

      return;
    }
    self.invite();
  };

  self.invite = function(){
    self.client_errors = ko.validation.group(self.selected_invitee(), { deep: true });
    if (self.client_errors().length === 0) {
      self.sendInvitation();
    } else {
      self.client_errors.showAllMessages();
    }
  };

  self.sendInvitation = function() {
    self.$invite_modal.modal('hide');

    var request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.invite_admin_course_path(self.selected_course().id()),
      data: { user: ko.mapping.toJS(self.selected_invitee()) }
    });

    request.done(function(data) {
      new Kadenze.Notice.success({ message: data.message });
      self.resetSelected();
    });

    request.fail(function(data) {
      console.warn('Failed in invite user:', data);
      new Kadenze.Notice.error({ message: xhr.responseJSON.message });
    });

    request.always(function() {
      $('.modal').modal('hide');
    });
  };

  /*----------------------------------------CATEGORY ASSIGNMENT FUNCTIONS---------------------------------------------*/

  self.categorySource = function(query, cb) {
    var filteredList = $.grep(self.categories(), function (item, index) {
      return item.name().toLowerCase().match(query);
    });

    var mapped = $.map(filteredList, function (item) { return { id: item.id(), name: item.name() }; });
    cb(mapped);
  };

  self.initCategoryTypeahead = function() {
    var tagsinput = self.$category_input.tagsinput({
      confirmKeys: [9, 13, 188],
      itemValue: 'id',
      itemText: 'name'
    });

    $('.bootstrap-tagsinput input', self.$category_input.parent()).typeahead({
      minLength: 0,
      hint: false,
      highlight: false
    }, {
      name: 'noname',
      displayKey: 'name',
      source: self.categorySource
    }).bind('typeahead:selected', $.proxy(function (obj, datum) {
      self.$category_input.tagsinput('add', datum);
      this.value = '';
    }));

    $('.bootstrap-tagsinput input', self.$category_input.parent()).bind('typeahead:opened', function () {
      var ev = $.Event('keydown');
      ev.keyCode = ev.which = 40;
      $(this).trigger(ev);
      $(this).typeahead('val', '');
      return true;
    });
  };

  self.selected_categories = function(key) {
    return $.map(self.$category_input.tagsinput('items'), function (item) { return key ? item[key] : item; });
  };

  self.selectCategory = function(item, event) {
    self.selected_course(item);

    self.$category_input.tagsinput('removeAll');
    ko.utils.arrayForEach(item.categories(), function(category) {
      self.$category_input.tagsinput('add', {id: category.id(), name: category.name()});
    });

    self.$category_modal.modal('show');
  };

  self.publish = function (item, event) {
    var course = item;
    var request = new Kadenze.AjaxRequest({
      type: 'PATCH',
      url:  Kadenze.Routes.publish_course_path(course.id()),
      data: { status: 'published' },
      loadingIndicator: {
        container: self.$el,
        positionTop: 'fixed'
      }
    });

    request.done(function(data) {
      self.draft_courses.remove(course);
      self.pending_courses.push(course);
      new Kadenze.Notice.success({ message: data.message });
    });

    request.fail(function(data) {
      console.warn('Unable to unpublish course:', data);
      new Kadenze.Notice.error({ message: data.responseJSON.message });
    });
  };

  self.confirmAndUnpublish = function (item, event) {
    var course = item;
    if(course.student_count() > 0) {
      var prompt = 'Are you sure you want to unpublish this course? (Any enrolled students will lose access)';
      Kadenze.UIUtil.confirmAction(prompt, function() {
        self.unpublish(course);
      });
    } else {
      self.unpublish(course);
    }
  };

  self.unpublish = function(course) {
    var request = new Kadenze.AjaxRequest({
      type: 'PATCH',
      url:  Kadenze.Routes.unpublish_course_path(course.id()),
      loadingIndicator: {
        container: self.$el,
        positionTop: 'fixed'
      }
    });

    request.done(function(data) {
      self.published_courses.remove(course);
      self.draft_courses.push(course);
      new Kadenze.Notice.success({ message: data.message });
    });

    request.fail(function(data) {
      console.warn('Unable to unpublish course:', data);
      new Kadenze.Notice.error({ message: data.responseJSON.message });
    });
  };

  /*----------------------------------------COURSE STATE MANAGEMENT FUNCTIONS-----------------------------------------*/

  self.saveCourse = function(item, event) {
    self.$category_modal.modal('hide');

    var request = new Kadenze.AjaxRequest({
      type: 'PATCH',
      url: Kadenze.Routes.admin_course_path(self.selected_course().id()),
      data: { category_ids: self.selected_categories('id') },
    });

    request.done(function(data) {
      var course = self.getSelectedCourse(),
        mapped_categories = ko.mapping.fromJS(self.selected_categories());

      course.categories(mapped_categories());
      self.resetSelected();
      new Kadenze.Notice.success({ message: data.message });
    });

    request.fail(function(data) {
      console.warn('Failed to save course:', data);
      new Kadenze.Notice.error({ message: data.message });
    });
  };

  self.approveCourse = function(item, event) {

    if(page == 'AdminDashboard') {
      self.selected_course(item.selected_course());
    } else {
      self.selected_course(item);
    }

    self.$category_modal.modal('hide');

    var request = new Kadenze.AjaxRequest({
      type: 'PATCH',
      url: Kadenze.Routes.approve_admin_course_path(self.selected_course().id()),
      data: { category_ids: self.selected_categories('id') }
    });

    request.done(function(data) {
      var course = self.getSelectedCourse(),
        mapped_categories = ko.mapping.fromJS(self.selected_categories());

      course.categories(mapped_categories());
      course.is_pending(false);
      course.is_published(true);

      self.pending_courses.remove(course);

      // Handle admin dashboard since published courses aren't listed there
      if(self.published_courses()) {
        self.published_courses.unshift(course);
      }

      self.resetSelected();
      new Kadenze.Notice.success({ message: data.message });
    });

    request.fail(function(data) {
      console.warn('Failed to approve course:', data);
      new Kadenze.Notice.error({ message: data.message });
    });
  };

  self.denyCourse = function(item, event) {
    var course = item,
      deletePrompt = 'Are you sure you want to deny this course?';

    Kadenze.UIUtil.confirmAction(deletePrompt, function() {

      var request = new Kadenze.AjaxRequest({
        type: 'PATCH',
        url:  Kadenze.Routes.deny_admin_course_path(course.id())
      });

      request.done(function(data) {
        course.is_published(false);
        course.is_pending(false);

        self.pending_courses.remove(course);

        new Kadenze.Notice.success({ message: data.message });
      });

      request.fail(function(data) {
        console.warn('Failed to deny course:', data);
        new Kadenze.Notice.error({ message: data.responseJSON.message });
      });

    });
  };

  self.deleteCourse = function(item, event) {
    var course = item,
      deletePrompt = 'Are you sure you want to remove this course? (This action cannot be undone)';

    Kadenze.UIUtil.confirmAction(deletePrompt, function() {

      var request = new Kadenze.AjaxRequest({
        type: 'DELETE',
        url:  Kadenze.Routes.admin_course_path(course.id()),
        loadingIndicator: {
          container: self.$el,
          positionTop: 'fixed'
        }
      });

      request.done(function(data) {
        self.courses.remove(course);
        self.published_courses.remove(course);
        self.pending_courses.remove(course);
        self.draft_courses.remove(course);
        self.archived_courses.remove(course);
        self.total_courses(self.total_courses() - 1)
        new Kadenze.Notice.success({ message: data.message });
      });

      request.fail(function(data) {
        console.warn('Failed to delete course:', data);
        new Kadenze.Notice.error({ message: data.responseJSON.message });
      });

    });
  };

  self.getSelectedCourse = function() {
    var selectedCourse;

    ko.utils.arrayFirst(self.courses(), function(course) {
      if (course.id() === self.selected_course().id()) {
        selectedCourse = course;
      }
    });

    return selectedCourse;
  };

  /*----------------------------------------COURSE SEARCH/FILTERING FUNCTIONS-----------------------------------------*/

  self.courseListing = function (url, params) {
    var request,
      requestUrl = url ? url : Kadenze.Routes.admin_courses_path();

    request = new Kadenze.AjaxRequest({
      type: 'GET',
      dataAsJSON: false,
      url: requestUrl,
      data: params,
      loadingIndicator: {
        container: self.$el
      }
    });


    request.done(function(data) {
      self.bindData(data);
      self.bindPaginationEvents();
      Kadenze.Layout.update(); // Helps reset the footer / sidebar when there's dramatic changes in the course list lengths
    });

    request.fail(function(data) {
      console.warn('Failed to get courses: ', data);
      new Kadenze.Notice.error({ message: I18n.t('notice.unexpected_error') });
    });
  };

  self.filterChanged = function () {
    var sortOption = self.getSort(self.selected_sort()),
      sortParam = sortOption ? sortOption.param : '',
      sortDirection = sortOption ? sortOption.direction: '',
      params = {
        in_categories: self.checkedCategories(),
        sort: sortParam,
        direction: sortDirection,
        in_terms: self.selected_terms(),
        q: self.searchQuery(),
        course_list: self.getActiveTab()
      };

    self.courseListing(null, $.param(params));
  };


  this.selectedCourseName = () => {
    if (this.selected_course())
      return this.selected_course().number() + ": " + this.selected_course().name()
  }

  this.pendingSelectedCourse = () => {
    return this.selected_course() && this.selected_course().is_pending()
  }

  self.selected_sort.subscribe(self.filterChanged);
  self.selected_terms.subscribe(self.filterChanged);
  self.checkedCategories.subscribe(self.filterChanged);

  self.getSort = function(id) {
    return _.find(self.sort_options(), function(option) { return option.id === id; });
  };

  self.getActiveTab = function() {
    return $('.tab-subnav .active .tab-subnav__tab-link').prop('href').split('#')[1];
  };

  const __construct = function(that) {
    console.log('constructor called for AdminCourseListingViewModel');
    that.bindData(data);
    // $('a[data-toggle="tab"]').on('shown.bs.tab', function (e){
    //   var url = Kadenze.Routes.admin_courses_path({page: 1});
    //   self.courseListing(url, { course_list: self.getActiveTab() });
    // });
  }(this);
}

